import {useTheme} from "@emotion/react";
import Markdown from "react-markdown";
import HashtagLink from "../../../elements/hashtagLink/index.jsx";
import {H1} from "../../../elements/semanticWrappers/index.jsx";
import {Text} from "../../../elements/text/index.js";
import SectionWrapper from "../../../layouts/SectionWrapper/index.jsx";
import {HashtagsWrapper, Image, TextWrapper, TitleWrapper} from "./styles.js";

export default function B1Herobanner({
  isFirstSection,
  isLastSection,
  heroBannerData,
  id,
}) {
  const {bg_color, desktop_image, taxonomies, text, title, mobile_image} = heroBannerData;
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;

  const image = isMobile ? mobile_image?.url || desktop_image?.url : desktop_image?.url;
  const alt = isMobile ? mobile_image?.alt || desktop_image?.alt : desktop_image?.alt;
  const imageTitle = isMobile
    ? mobile_image?.title || desktop_image?.title
    : desktop_image?.title;
  const isImg = !!image;
  const caption = isMobile
    ? mobile_image?.caption || desktop_image?.caption
    : desktop_image?.caption;

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      <TitleWrapper>
        <H1>
          <Markdown>{title}</Markdown>
        </H1>
        {!!taxonomies?.length && (
          <HashtagsWrapper>
            {taxonomies?.length &&
              taxonomies?.map((hashtag) => (
                <HashtagLink key={hashtag.term_id} to={`#${hashtag.slug}`}>
                  {hashtag.name}
                </HashtagLink>
              ))}
          </HashtagsWrapper>
        )}
      </TitleWrapper>

      {isImg ? (
        <Image
          src={image}
          alt={alt || "hero image"}
          title={imageTitle || "hero image"}
          loading="lazy"
        />
      ) : null}

      {!!caption && (
        <Text
          styles={{
            gridColumn: isMobile ? "1/-1" : "2/4",
            marginTop: 8,
            color: "#737373",
            whiteSpace: "nowrap",
          }}
          type="textSmallRegular"
        >
          {caption}
        </Text>
      )}
      <TextWrapper isImg={isImg}>
        <Text type="titleExtraSmall">{text}</Text>
      </TextWrapper>
    </SectionWrapper>
  );
}
